import type { ReactNode } from "react";
import { useIntl } from "@/infra/locale";
import type { CopyKeyCare } from "@akina/infra";
import { Dialog, Text, ErrorMessage, Button } from "@akina/presentation";

type LegalAcceptanceModalLayoutProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  titleMessageId: CopyKeyCare;
  descriptionMessageId: CopyKeyCare;
  errorMessageId: CopyKeyCare;
  buttonMessageId: CopyKeyCare;
  hasError: boolean;
  isLoading: boolean;
  onAccept: () => void;
  children: ReactNode;
};

export function LegalAcceptanceModalLayout({
  open,
  onOpenChange,
  titleMessageId,
  descriptionMessageId,
  errorMessageId,
  buttonMessageId,
  hasError,
  isLoading,
  onAccept,
  children,
}: Readonly<LegalAcceptanceModalLayoutProps>) {
  const { formatMessage } = useIntl();

  return (
    <Dialog
      withClose={false}
      open={open}
      onOpenChange={onOpenChange}
      onInteractOutside={event => event.preventDefault()}
      className="no-scrollbar flex flex-col">
      <Text size="3xl" className="pb-10">
        {formatMessage({ id: titleMessageId })}
      </Text>
      <div className="flex flex-col gap-6">
        <Text size="base">
          {formatMessage({ id: descriptionMessageId })}
        </Text>
        {children}
        {hasError ? (
          <ErrorMessage error={formatMessage({ id: errorMessageId })} size="xs" className="mt-0" />
        ) : null}
        <Button
          loading={isLoading}
          className="ml-auto max-w-fit object-contain text-right"
          onClick={onAccept}>
          {formatMessage({ id: buttonMessageId })}
        </Button>
      </div>
    </Dialog>
  );
}
